import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=3207356e&"
import script from "./MenuTree.vue?vue&type=script&lang=ts&"
export * from "./MenuTree.vue?vue&type=script&lang=ts&"
import style0 from "./MenuTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports